export default {
  path: '/store-center2',
  meta: {
    title: '店铺首页',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store-center2`),
}



// WEBPACK FOOTER //
// ./src/views/StoreCenter2/router.js